import SFetch from '@app/utils/sfetch'
import type {
  ReconciliationTemplate,
  Export,
  PermanentEntriesResponse,
  DocumentEntry,
} from './types'

export const fetchReconciliationTemplates = ({
  companyId,
  ledgerId,
}: {
  companyId?: string
  ledgerId?: string
} = {}): Promise<ReconciliationTemplate[] | null> =>
  SFetch.json(
    window.Silverfin.Routes.for_mentions_ledger_reconciliation_texts_path(
      window.Silverfin.currentFirmId,
      companyId || window.Silverfin.currentCompanyId,
      ledgerId ? Number(ledgerId) : window.Silverfin.currentLedgerId()
    )
  )

export const fetchExports = ({
  companyId,
  ledgerId,
}: {
  companyId?: string
  ledgerId?: string
} = {}): Promise<Export[] | null> =>
  SFetch.json(
    window.Silverfin.Routes.all_in_ledger_exports_path(
      window.Silverfin.currentFirmId,
      companyId || window.Silverfin.currentCompanyId,
      {
        ledger_id: ledgerId
          ? Number(ledgerId)
          : window.Silverfin.currentLedgerId(),
      }
    )
  )

export const fetchPermanentDocuments = (
  options: Record<string, unknown> = {}
): Promise<PermanentEntriesResponse | null> =>
  SFetch.json(
    window.Silverfin.Routes.select_from_documents_permanent_entries_path(
      options
    )
  )

export const fetchPeriodSpecificDocuments = (
  options: Record<string, unknown> = {}
): Promise<DocumentEntry[] | null> =>
  SFetch.json(
    window.Silverfin.Routes.period_specific_documents_permanent_entries_path(
      options
    )
  )
